import { Label, Tag, Text } from "react-konva";
import type Konva from "konva";
import { usePlacementZoomAndPan } from "../hooks/usePlacementZoomAndPan";

export type TextLabelProps = {
  x: number;
  y: number;
  tagFill: string;
  textFill: string;
  ref?: React.RefObject<Konva.Label | null>;
  children: string;
  align?: "left" | "center" | "right";
  fontSize?: number;
  stroke?: string | CanvasGradient;
  strokeWidth?: number;
  lineHeight?: number;
};

const FONT_SIZE = 10;
const PADDING = 4;

/**
 * Reusable size label rendered with Konva primitives.
 * Uses conditional rendering instead of the Konva `visible` prop.
 */
export function TextLabel({
  x,
  y,
  tagFill,
  textFill,
  lineHeight = 1,
  children,
  ref,
  align = "left",
  fontSize = FONT_SIZE,
  stroke,
  strokeWidth
}: TextLabelProps) {
  const { zoom } = usePlacementZoomAndPan();

  const textHeight = fontSize + PADDING * 2;
  const centeredY = y - textHeight / 2 / zoom;

  const tagProps: Konva.TagConfig = {
    fill: tagFill,
    cornerRadius: 5,
    scaleX: 1 / zoom,
    scaleY: 1 / zoom,
    ...(stroke !== undefined && { stroke }),
    ...(strokeWidth !== undefined && { strokeWidth })
  };

  return (
    <Label x={x} y={centeredY} ref={ref}>
      <Tag {...tagProps} />
      <Text
        text={children}
        lineHeight={lineHeight}
        fill={textFill}
        padding={PADDING}
        fontSize={fontSize}
        fontStyle="700"
        scaleX={1 / zoom}
        scaleY={1 / zoom}
        align={align}
      />
    </Label>
  );
}
